<template>
	<div :class="`log-action-menu-wrapper log-action-menu-wrapper-${dynamicId}`">
		<div class="post-smtp-log-action-menu-wrapper" :style="showHideActionMenu">
			<div class="post-smtp-link">
				<a
					@click="e => viewDetails( e, 'show_view' )"
					href="#"
				>
					<i>
						<svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
							<path d="M7.99999 6C7.46956 6 6.96085 6.21071 6.58578 6.58579C6.2107 6.96086 5.99999 7.46957 5.99999 8C5.99999 8.53043 6.2107 9.03914 6.58578 9.41421C6.96085 9.78929 7.46956 10 7.99999 10C8.53042 10 9.03913 9.78929 9.4142 9.41421C9.78928 9.03914 9.99999 8.53043 9.99999 8C9.99999 7.46957 9.78928 6.96086 9.4142 6.58579C9.03913 6.21071 8.53042 6 7.99999 6ZM7.99999 11.3333C7.11594 11.3333 6.26809 10.9821 5.64297 10.357C5.01785 9.7319 4.66666 8.88406 4.66666 8C4.66666 7.11595 5.01785 6.2681 5.64297 5.64298C6.26809 5.01786 7.11594 4.66667 7.99999 4.66667C8.88405 4.66667 9.73189 5.01786 10.357 5.64298C10.9821 6.2681 11.3333 7.11595 11.3333 8C11.3333 8.88406 10.9821 9.7319 10.357 10.357C9.73189 10.9821 8.88405 11.3333 7.99999 11.3333ZM7.99999 3C4.66666 3 1.81999 5.07333 0.666656 8C1.81999 10.9267 4.66666 13 7.99999 13C11.3333 13 14.18 10.9267 15.3333 8C14.18 5.07333 11.3333 3 7.99999 3Z" fill="#231F20"/>
						</svg>
					</i>
					{{ i18n.action.view }}
				</a>
			</div>
			<div class="post-smtp-link">
				<a href="#" @click="e => viewDetails( e, 'resend_email' )">
					<i>
						<svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
							<path d="M1.34001 14L15.3333 8L1.34001 2L1.33334 6.66667L11.3333 8L1.33334 9.33333L1.34001 14Z" fill="#231F20"/>
						</svg>
					</i>
					{{ i18n.action.resend }}
				</a>
			</div>
			<div class="post-smtp-link">
				<a
					@click="e => viewDetails( e, 'show_transcript' )"
					href="#"
				>
					<i>
						<svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
							<g clip-path="url(#clip0_219_334)">
								<path fill-rule="evenodd" clip-rule="evenodd" d="M7.99999 1.33331V5.66665C7.99999 5.93186 8.10535 6.18622 8.29288 6.37375C8.48042 6.56129 8.73477 6.66665 8.99999 6.66665H13.3333V13.3333C13.3333 13.6869 13.1928 14.0261 12.9428 14.2761C12.6928 14.5262 12.3536 14.6666 12 14.6666H3.99999C3.64637 14.6666 3.30723 14.5262 3.05718 14.2761C2.80713 14.0261 2.66666 13.6869 2.66666 13.3333V2.66665C2.66666 2.31302 2.80713 1.97389 3.05718 1.72384C3.30723 1.47379 3.64637 1.33331 3.99999 1.33331H7.99999ZM9.99999 9.99998H5.99999C5.82318 9.99998 5.65361 10.0702 5.52859 10.1952C5.40356 10.3203 5.33332 10.4898 5.33332 10.6666C5.33332 10.8435 5.40356 11.013 5.52859 11.1381C5.65361 11.2631 5.82318 11.3333 5.99999 11.3333H9.99999C10.1768 11.3333 10.3464 11.2631 10.4714 11.1381C10.5964 11.013 10.6667 10.8435 10.6667 10.6666C10.6667 10.4898 10.5964 10.3203 10.4714 10.1952C10.3464 10.0702 10.1768 9.99998 9.99999 9.99998ZM6.66666 7.33331H5.99999C5.82318 7.33331 5.65361 7.40355 5.52859 7.52857C5.40356 7.6536 5.33332 7.82317 5.33332 7.99998C5.33332 8.17679 5.40356 8.34636 5.52859 8.47138C5.65361 8.59641 5.82318 8.66665 5.99999 8.66665H6.66666C6.84347 8.66665 7.01304 8.59641 7.13806 8.47138C7.26309 8.34636 7.33332 8.17679 7.33332 7.99998C7.33332 7.82317 7.26309 7.6536 7.13806 7.52857C7.01304 7.40355 6.84347 7.33331 6.66666 7.33331ZM9.33332 1.36198C9.58591 1.41555 9.81751 1.54131 9.99999 1.72398L12.9427 4.66665C13.1253 4.84913 13.2511 5.08073 13.3047 5.33331H9.33332V1.36198Z" fill="#231F20"/>
							</g>
							<defs>
								<clipPath id="clip0_219_334">
									<rect width="16" height="16" fill="white"/>
								</clipPath>
							</defs>
						</svg>
					</i>
					{{ i18n.action.transcript }}
				</a>
			</div>
			<div v-if="'failed' === item.status" class="post-smtp-link">
				<a @click="e => viewDetails( e, 'show_error' )" href="#">
					<i>
						<svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
							<path d="M0.666656 14H15.3333L7.99999 1.33331L0.666656 14ZM8.66666 12H7.33332V10.6666H8.66666V12ZM8.66666 9.33331H7.33332V6.66665H8.66666V9.33331Z" fill="#231F20"/>
						</svg>
					</i>
					{{ i18n.action.details }}
				</a>
			</div>
		</div>

		<div class="post-smtp-error-details" v-if="show_popup">
			<div class="post-smtp-details-wrapper">

				<a class="post-smtp-close-button" @click="closeDetails" href="#">&times</a>

				<div v-if="content_loading" style="width: 100%;height: calc( 100% - 25px );position:absolute;top: 25px;left: 0;display: flex;justify-content: center;align-items: center;">
					<div>loading...</div>
				</div>

				<div v-if="show_error">
					{{ item.error }}
				</div>
				<div
					v-if="show_transcript"
				>
					{{ session_transcript }}
				</div>
				<div v-if="show_view">

					<div class="post-smtp--headers">
						<table>
							<tbody>
              <tr>
                <td>
                  <strong>
                    {{ i18n.headers.from }}:
                  </strong>
                </td>
                <td v-html="message_object.from"></td>
              </tr>
              <tr>
                <td>
                  <strong>
                    {{ i18n.headers.to }}:
                  </strong>
                </td>
                <td v-html="message_object.to"></td>
              </tr>
              <tr>
                <td>
                  <strong>
                    {{ i18n.headers.date }}:
                  </strong>
                </td>
                <td v-html="message_object.date"></td>
              </tr>
              <tr>
                <td>
                  <strong>
                    {{ i18n.headers.subject }}:
                  </strong>
                </td>
                <td v-html="message_object.subject"></td>
              </tr>
              <tr>
                <td>
                  <strong>
                    {{ i18n.headers.deliveryURI }}:
                  </strong>
                </td>
                <td v-html="message_object.delivery_uri"></td>
              </tr>
              </tbody>
						</table>
						<hr>
						<div>
							<iframe
								width="100%"
								height="310px"
								:src="message_object.message_url"
							></iframe>
						</div>
					</div>

				</div>

				<div v-if="resend_email">
					<div class="resend-email-wrapper">

						<div class="form-group">
							<label for="email">{{ i18n.resendEmail.emailAddress }}</label>
							<textarea v-model="sent_to" class="form-control">{{ item.sent_to }}</textarea>
							<p class="description" style="margin-bottom: 15px;">
								<strong>{{ i18n.resendEmail.description }}</strong>
							</p>

							<button @click="e => resendEmail( e )" class="post-smtp-button primary">{{ i18n.resendEmail.button }}</button>
						</div>
					</div>
				</div>

			</div>
		</div>

		<div @click="() => openActionMenu( item )" class="email-menu-wrapper">

			<span class="email-menu-action"></span>
			<span class="email-menu-action"></span>
			<span class="email-menu-action"></span>
		</div>
	</div>
</template>

<script>
export default {
	name: 'PostSmtpLogActionMenu',

	props: {
		item: {
			type: Object,
			required: true,
		},
		dynamicId: {
			type: String,
			required: true,
		}
	},

	data: ( vm ) => ( {
		plugin_dir_url: vm.$parent.plugin_dir_url,
		admin_url: vm.$parent.admin_url,
    i18n: postSmtpNewDashboard.i18n.logActionMenu,

		show_popup: false,
		show_error: false,
		show_view: false,
		show_transcript: false,
		resend_email: false,
		session_transcript: 'Loading...',

		content_loading: false,

		message_object: {
			from: '',
			to: '',
			date: '',
			subject: '',
			delivery_uri: '',
			message_url: '',
		},

		sent_to: '',

		open_action_menu: false,
	} ),

	watch: {
		show_popup( val ) {
			if ( ! val ) {
				this.show_error       = false;
				this.show_view        = false;
				this.show_transcript  = false;
				this.resend_email     = false;
				this.open_action_menu = false;

				this.session_transcript = 'Loading...';

				this.message_object.from         = '';
				this.message_object.to           = '';
				this.message_object.date         = '';
				this.message_object.subject      = '';
				this.message_object.delivery_uri = '';
				this.message_object.message_url  = '';

				this.$emit( 'close-log-menu', this.item );
			}
		},


	},

	computed: {
		showHidePopup() {
			var display;

			if ( this.show_popup ) {
				display = 'block';
			} else {
				display = 'none';
			}

			return {
				display: display,
			};
		},

		showHideActionMenu() {
			return {
				display: this.open_action_menu ? 'block' : 'none',
			};
		},
	},

	methods: {
		viewDetails(e, value ) {
			e.preventDefault();

			this.$nextTick( () => {
				this.show_popup = true;

				if ( 'resend_email' !== value ) {
					if ('show_error' !== value) {
						this.$nextTick(() => {
							this.getDetails(value);
						});
					}
				} else {
					this.sent_to = this.item.sent_to;
				}
				this[value] = true;
			} )
				.then( () => {

				} )
		},

		closeDetails( e ) {
			e.preventDefault();

			this.show_popup = false;
		},

		getDetails( value ) {
			this.content_loading = true;
			return axios.get( 'get-details', {
				params: {
					id: this.item.id,
					type: value,
				},
			} ).then( response => {
				this.content_loading = false;
				if ( 'show_transcript' === value ) {
					this.session_transcript = response.data.details.session_transcript;
				} else if ( 'show_view' === value ) {
					let details = response.data.details;

					this.message_object.from         = details.from_header;
					this.message_object.to           = details.to_header;
					this.message_object.date         = details.time;
					this.message_object.subject      = details.original_subject;
					this.message_object.delivery_uri = details.transport_uri;
					this.message_object.message_url  = details.log_url;

				}
				this[ value ] = true;
			} );
		},

		resendEmail( e ) {
			e.preventDefault();

			axios.post( 'resend-email', {
				id: this.item.id,
				sent_to: this.sent_to,
			} )
				.then( response => {
					this.show_popup = false;

					this.$emit( 'email-triggered', response.data.details );
				} );
		},

		openActionMenu( item ) {
			this.open_action_menu = ! this.open_action_menu;
		},
	},

	mounted() {

		document.body.addEventListener( 'click', ( event ) => {
			if ( ! event.target.closest( '.log-action-menu-wrapper-' + this.dynamicId ) ) {
				this.open_action_menu = false;
			}
		} );
	}
}
</script>

<style scoped>
.post-smtp-log-action-menu-wrapper {
	display: inline-flex;
	padding: 16px 20px;
	flex-direction: column;
	align-items: flex-start;
	gap: 12px;

	border-radius: 4px;
	background: #FFF;
	box-shadow: 0px 0px 20px 0px rgba(35, 31, 32, 0.10);

	position: absolute;

	z-index: 925;

	top: -13px;
	right: 32px;

	width: 100px;
}

.post-smtp-log-action-menu-wrapper a {
	color: #231F20;
	font-family: Poppins;
	font-size: 12px;
	font-style: normal;
	font-weight: 400;
	line-height: 16px; /* 133.333% */

	text-decoration: none;
}

.post-smtp-link i {
	margin-right: 6px;
}

.post-smtp-link {
	margin-bottom: 12px;
}

.post-smtp-link:last-child {
	margin-bottom: 0;
}

.post-smtp-error-details {
	width: 100%;
	height: 100%;
	position: fixed;
	top: 0;
	left: 0;
	display: flex;
	justify-content: center;
	align-items: center;
	background: rgba(0, 0, 0, 0.5);
	backdrop-filter: blur( 1px );
	z-index: 99999;
}

.post-smtp-details-wrapper {
	width: 700px;
	height: 500px;
	padding: 20px;
	box-shadow: 0 2px 16px rgb(0 0 0 / 50% );
	background: #fff;
	overflow: auto;
	position: relative;
}

.post-smtp-close-button {
	position: absolute;
	top: 10px;
	right: 10px;
	font-size: 24px;
	color: #231F20;
	text-decoration: none;
}

.resend-email-wrapper {
	width: 100%;
	height: 500px;

	display: flex;
	justify-content: center;
	align-items: center;
}

.form-group {
	width: 100%;
}

.form-group label {
	display: block;
	margin-bottom: 6px;
}

.form-group textarea {
	width: 100%;
	height: 100px;
	padding: 10px;
	border: 1px solid #ccc;
	border-radius: 4px;
}

.form-control {
	width: 100%;
	height: 40px;
	padding: 10px;
	border: 1px solid #ccc;
	border-radius: 4px;
}

.post-smtp-button {
	padding: 10px 20px;
	border: none;
	border-radius: 4px;
	cursor: pointer;
}

.post-smtp-button.primary {
	background: #0073aa;
	color: #fff;
}

.email-menu-wrapper {
	position: absolute;
	right: 27px;
	top: 0px;
	cursor: pointer;
}

.email-menu-action::after {


	content: '';
	display: block;
	width: 4px;
	height: 4px;
	border-radius: 50%;
	background: #B0B0B0;
	margin: 4px 0;
}

</style>